function runCustomScript() {
$(document).ready(function() {
    $(document).on('click', '.add-to-cart-option', function(event) {
        $(this).prev('.ib-vari-inner').slideDown();
       $(this).closest('.grid__item').siblings().find('.card__content .ib-vari-inner').slideUp();
      $('.ib-varient-overlay').css({'display': 'block'});
      $(this).parent().parent('.quick-add').css({'z-index': '10001'});
    });

    $(document).on('click', '.product-options-close', function(event) {
        event.preventDefault();
        var $closestVariInner = $(this).closest('.ib-vari-inner');
        var $overlay = $('.ib-varient-overlay');
        var $quickAdd = $(this).closest('.quick-add');
        $closestVariInner.slideUp().removeClass('ib-first-selected');
        $overlay.css({'display': 'none'});
        $quickAdd.css({'z-index': '10'});
    });


  // Function to update the Add to Cart button visibility
    function updateAddToCartButton(container) {
        // Get the value of the checked radio button within the specified container
        var selectedVariantId = container.find('.product-variant-input:checked').val();
        container.find('.ib-add-to-cart-button').hide();
        // Show the add-to-cart button that matches the selected variant
        container.find('.ib-add-to-cart-button[data-variant-id="' + selectedVariantId + '"]').show();
    }

      // Delegate the change event to the document for dynamically added .product-variant-input
    $(document).on('change', '.ib-sh-card .product-variant-input', function() {
        var container = $(this).closest('.ib-sh-card');
        updateAddToCartButton(container);
    });

    // Iterate over each product container and initialize
    $('.ib-sh-card').each(function() {
        var container = $(this);
        // Click the first .product-variant-input within the current container
        container.find('.product-variant-input').first().prop('checked', true).trigger('change');
        // Call the function to handle the initially checked input
        updateAddToCartButton(container);
    });
});

  


$(document).on('click', '.product-variants .product-variant-input', function(e) {
  // $('.product-variant-input', '.product-variants').on('click', function(e) {
  $(this).parent().addClass('ib-active-collection-input');
  $(this).parent().siblings().removeClass('ib-active-collection-input');
    $(this).parent().parent().prev('.product-option-name').children('.selected-option').text($(this).next('.product-variant-title').text());
    // Update price.
    $(this).parent().parent().parent().parent().find('.product-info-price').attr('data-checked', 'false');
    $(this).parent().parent().parent().parent().find('.product-info-price[data-variant-id="' + $(this).val() + '"]').attr('data-checked', 'true');
  });

    $(document).mouseup(function(e) {
      var container = $('.product-options-open .product-options-wrapper');
      // If the target of the click isn't the container nor a descendant of the container.
      if (!container.is(e.target) && container.has(e.target).length === 0) {
        $('.product-options-wrapper-overlay').removeClass('on');
        $('.product-options-wrapper').removeClass('slide-up');
        $('.page-wrap').removeClass('product-options-open');
      }
    });
}

$(document).ready(function() {
    runCustomScript();
});





